import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Heart } from "lucide-react";
import { haptic } from "@/lib/utils";

const conditionLabel = {
  neuf_etiquette: "Neuf",
  tres_bon: "Très bon",
  bon: "Bon",
  correct: "Correct",
};

export default function ProductCard({ product, onWishlist, isWishlisted, size = "default" }) {
  const img = product.images?.[0];
  return (
    <div className="product-card group relative" data-testid={`product-card-${product.product_id}`}>
      <Link to={`/produit/${product.product_id}`} className="block">
        <div className="product-img-wrap aspect-square mb-2 relative">
          {img ? (
            <img src={fileUrl(img)} alt={product.title} className="product-img w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center label">Pas de photo</div>
          )}
          {product.status === "sold" && (
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
              <span className="pill pill-coral text-base px-3 py-1.5">Vendu</span>
            </div>
          )}
          <div className="absolute top-2 left-2">
            <span className="pill pill-outline bg-white/95">{conditionLabel[product.condition] || product.condition}</span>
          </div>
        </div>
        <div className="px-0.5">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="label truncate">{product.brand || "Sans marque"}</p>
              <h3 className="text-sm font-bold truncate mt-0.5" style={{ letterSpacing: "-0.01em" }}>{product.title}</h3>
              {product.size && <p className="text-xs text-[color:var(--color-text-muted)] mt-0.5">Taille {product.size}</p>}
            </div>
            <div className="text-right shrink-0">
              <span className="font-black text-base whitespace-nowrap" style={{color: "var(--color-coral)"}}>{product.price?.toFixed(0)}€</span>
            </div>
          </div>
        </div>
      </Link>
      {onWishlist && (
        <button
          data-testid={`wishlist-btn-${product.product_id}`}
          onClick={(e) => { e.preventDefault(); haptic(); onWishlist(product); }}
          className="absolute top-2 right-2 w-9 h-9 flex items-center justify-center bg-white/95 border-2 border-black tap-flash"
        >
          <Heart size={16} strokeWidth={2.4} fill={isWishlisted ? "#FF4500" : "none"} color={isWishlisted ? "#FF4500" : "#000"} />
        </button>
      )}
    </div>
  );
}
